import type { SoundDefinition } from "./SoundDefinition.js";
import type {
  SoundPlayer,
  SoundPlayHandle,
  SoundPlayOptions,
} from "./SoundPlayer.js";

/**
 * No-op SoundPlayer — 테스트·SSR·사운드 미지원 환경용.
 *
 * 모든 메서드는 부작용 없이 즉시 반환. `play`는 stop 호출용 가짜 handle을 반환.
 * 테스트에서 호출 시퀀스를 검증하려면 `playLog` 배열을 확인.
 */
export class NullSoundPlayer implements SoundPlayer {
  /** 호출 로그 — 테스트 검증용. 본 필드를 외부에서 직접 비우는 행위는 권장하지 않음. */
  readonly playLog: Array<{ id: string; options: SoundPlayOptions }> = [];
  /** `stop(handle)` 호출 시점에 받은 handle 시퀀스 — 정지 순서/대상 검증용. */
  readonly stopLog: SoundPlayHandle[] = [];
  /** `setVolume(handle, volume)` 호출 인자 시퀀스 — 볼륨 propagation 검증용. */
  readonly setVolumeLog: Array<{ handle: SoundPlayHandle; volume: number }> = [];
  /** `stopAll()` 누적 호출 횟수 — 카운터 검증용 (인자 없으므로 횟수만). */
  stopAllCalls = 0;

  async load(_definition: SoundDefinition): Promise<void> {
    return;
  }

  play(definition: SoundDefinition, options: SoundPlayOptions): SoundPlayHandle {
    const handle: SoundPlayHandle = { id: definition.id, key: Symbol(definition.id) };
    this.playLog.push({ id: definition.id, options });
    return handle;
  }

  stop(handle: SoundPlayHandle): void {
    this.stopLog.push(handle);
  }

  setVolume(handle: SoundPlayHandle, volume: number): void {
    this.setVolumeLog.push({ handle, volume });
  }

  stopAll(): void {
    this.stopAllCalls += 1;
  }

  dispose(): void {
    this.playLog.length = 0;
    this.stopLog.length = 0;
    this.setVolumeLog.length = 0;
    this.stopAllCalls = 0;
  }
}
